import Link from "next/link";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "Where are my seats located?",
    answer: "Seat locations vary by game.",
  },
  {
    question: "Where are my tickets?",
    answer:
      "You will receive a text on the Thursday before the game with a link to access your tickets in your Jaguars Account Manager.",
  },
  {
    question: "How are tickets sent to me?",
    answer:
      "You will receive a text when tickets are delivered to your Ticketmaster account. You will need to login there to access your tickets.",
  },
  {
    question: "Where will my seats be located?",
    answer:
      "All seats are located on the east side upper deck. You will receive a seat location when your ticket is delivered to your Ticketmaster account.",
  },
  {
    question: "Can these tickets be transferred to a friend?",
    answer: "These tickets are not for resale.",
  },
  {
    question: "Can I link tickets with other pass holders?",
    answer:
      "You can link your pass with other pass holders using My Groups located within the portal on the right navigation. This allows you to create and join ticket groups to sit with fellow pass holders.",
  },
  {
    question: "Can I bring a friend to a game?",
    answer:
      "Guest tickets are available for purchase for select games. You will receive a text notification the week of the game with an update on if there is ticket availability for the game.",
  },
  {
    question: "Can I receive a refund if I cannot attend a game?",
    answer: "We do not issue any refunds for games you are not able to attend.",
  },
  {
    question: "How can I get a refund and cancel my pass?",
    answer:
      "Please contact the Jaguars box office if you have any questions about refunds or need to cancel your pass.",
  },
];

export const TERMS_AND_CONDITION = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link
      target={"_blank"}
      href={
        "https://cdn.prod.website-files.com/66b3d5184e88b53f24e71360/6836259e2aac5657874b9955_Attend%20Terms%20of%20Use%20052425.pdf"
      }
    >
      Terms & Conditions
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      href={
        "https://cdn.prod.website-files.com/66b3d5184e88b53f24e71360/683625a812daf6ceadcbe532_Attend%20Privacy%20Policy%20052725.pdf"
      }
    >
      Privacy Policy
    </Link>
    .
  </>
);
